import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { firestore } from '../../../firebase';
import CardFlip from '../Card/CardFlip'

function HomeDetails() {

    const [links, setLinks] = useState([]);

    useEffect(() => {
        const linksRef = firestore.collection("site_details").doc("X0LJ5z6LWL0qF8AluQLA").collection("home_cards");
        linksRef.onSnapshot(({docs}) => {
            const links = docs.map(doc => {
                return {id: doc.id, ...doc.data()} 
            });
            setLinks(links)
        })
    }, [])

    return (
        <div className="row mt-5">
            {links?.map((card, index) => {
                return (
                    <div className="col-md-6 col-lg-4 mt-2" key={index}>
                        <div className="card">
                            <img src={card.image} alt={card.title} className="img-fluid" />
                            <div className="card-body">
                                <Link to={card.link}><h6 className="font-weight-bold">{card.title}</h6></Link>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    )

}
export default HomeDetails